import { HttpContextToken } from "@angular/common/http";

export const SkipBy404TokenInterceptor = new HttpContextToken(() => true);
